import { ICategory } from '@Encore-FastStartup-Phase-Out/encore-shared';
import { makeAutoObservable } from 'mobx';

import { CategoryApi } from '../api/CategoryApi';

export class CategoryStore {
  api: CategoryApi;
  loading: boolean = false;
  categories: ICategory[] = [];
  totalCategories: number = 0;

  constructor() {
    this.api = new CategoryApi();
    makeAutoObservable(this, undefined, { autoBind: true });
  }

  setCategories(categories: ICategory[]) {
    this.categories = categories;
  }

  setTotalCategories(totalCategories: number) {
    this.totalCategories = totalCategories;
  }

  setLoading(loading: boolean) {
    this.loading = loading;
  }

  async getCategories() {
    this.setLoading(true);

    try {
      const response = await this.api.getCategories();
      this.setCategories(response);
    } catch (error) {
      console.error(error);
    } finally {
      this.setLoading(false);
    }
  }
}
